import React, { useMemo } from 'react';

import { useRecoilState } from 'recoil';
import styled from 'styled-components';

import { addNodeMenuState } from '../atoms/add-node-menu-atom';

import type { NodeType } from '../models';

type AddNodeHandleProps = {
  isConnected?: boolean;
  onAdd: (nodeType: NodeType, edgeType?: 'next' | 'no' | 'yes') => void;
  type?: 'next' | 'no' | 'yes';
};

type HandleStyle = {
  icon: string;
  position: { left: string };
};

export function AddNodeHandle({ type = 'next', onAdd, isConnected }: AddNodeHandleProps) {
  const [, setPopupState] = useRecoilState(addNodeMenuState);

  const { position, icon } = useMemo<HandleStyle>(() => {
    if (type === 'no') {
      return { position: { left: '10%' }, icon: 'No' };
    }
    if (type === 'yes') {
      return { position: { left: '90%' }, icon: 'Yes' };
    }
    return { position: { left: '50%' }, icon: '+' };
  }, [type]);

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setPopupState({
      isOpen: true,
      anchorEl: e.currentTarget as HTMLElement,
      onAdd,
      conditionalAllowed: !isConnected,
    });
  };

  return (
    <HandleWrapper style={position}>
      <HandleConnector />
      <StyledHandle onClick={handleClick}>
        <ActionLabel $type={type}>{icon}</ActionLabel>
      </StyledHandle>
    </HandleWrapper>
  );
}

const HandleWrapper = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: -12px;
  top: 100%;
  transform: translateX(-50%);
`;

const HandleConnector = styled.div`
  width: 1px;
  background: var(--color-gray-30);
  margin-bottom: -1px;
  height: var(--sizes-70);
`;

const StyledHandle = styled.div`
  min-width: var(--sizes-60) !important;
  padding-left: var(--sizes-10);
  padding-right: var(--sizes-10);
  height: var(--sizes-60) !important;
  background: var(--color-blue-60) !important;
  border: none !important;
  border-radius: var(--sizes-10) !important;
  cursor: pointer !important;
  display: flex !important;
  align-items: center;
  justify-content: center;

  &:hover {
    background: var(--color-blue-70) !important;
  }
`;

const ActionLabel = styled.span<{ $type: 'next' | 'no' | 'yes' }>`
  color: white;
  font: ${({ $type }) => ($type === 'yes' || $type === 'no' ? 'var(--font-extra-small-12pt-normal)' : '')};
  line-height: 1;
  user-select: none;
`;
